<template>
  <div>
    <van-nav-bar title="发帖" left-arrow  @click-left="goBack" right-text="发布" @click-right="addTopic">

      <span slot="right" style="font-size: 14px;color: #43b292"> 发布 </span>
<!--      <van-button slot="right" icon="share" size="small" round> 发布 </van-button>-->
    </van-nav-bar>

    <van-cell-group>
      <van-field ref="title"
              v-model="title"
              rows="1"
              autosize
                 maxlength="150"
              type="textarea"
              placeholder="请输入标题"
              required
      />
      <van-field ref="postContent"
              v-model="content"
              required
              rows="5"
              autosize
              type="textarea"
              maxlength="500"
              placeholder="请输入内容"
              show-word-limit
      />
      <van-uploader v-model="imgList" result-type="file" style="margin-top:10px;color: #43b292;"
                    :before-delete="delPic"
                    :after-read="afterRead"
                    :before-read = "beforeRead"
                    upload-text="添加图片"
      >
<!--        <i class="wcc-icon wcc-icon-addimg van-uploader__upload-icon"></i>-->
<!--        <span class="van-uploader__upload-text">添加图片</span>-->
      </van-uploader>
    </van-cell-group>
    <div>

    </div>


<!--    <div v-for="item in imgList">-->
<!--      <div>{{JSON.stringify(item)}}{{item.file.name}}</div>-->
<!--    </div>-->
  </div>
</template>

<script>
// @ is an alias to /src
import {Toast} from "vant"

export default {
  name: 'home',
  props:[ ],
  components: {
  },
  data:function(){
    return {
      title:'',
      content:'',
      imgList:[ ]
    }
  },
  methods:{
    goBack:function(){
      this.$router.push("/");
    },
    addTopic:function(){
      var app = this;

      if(!app.title || app.title.length<5 ){
         Toast('填写标题,至少5个字');
        app.$refs.title.focus();
         return ;
      }

      if(!app.content || app.content.length<8){

        Toast('填写内容,至少8个字');
        app.$refs.postContent.focus();
        return ;
      }

      var content = app.content;
      app.imgList.forEach(function(item){
        console.log("item",item);
        content = content.replace('[图片:'+item.file.name+']','<img src="'+item.url+'" style="max-width: 200px">')
      });

      app.axios.post("/bbsApi/addTopic", {
        title: app.title,
        content: content
      }).then(function(res){
        if(res.data.errcode=="suc"){
          app.$router.push("/");
        }
      })
    },
      afterRead(file,detail){
          this.imgList.forEach(function(item){
              item.url = item.file.url;
          })
          console.log("afterRead",file)
      },
    beforeRead:function(file,detail){
      var app = this;
      var formData = new FormData();
      var filename = file.name;
      formData.append('file',file,file.name)

      return app.axios.post("/bbsApi/uploadFile",formData,{
        headers: {'Content-Type': 'multipart/form-data1'}
      }).then(function(res){
        if(res.data.errcode=='suc'){
          var imgUrl = res.data.data.url;
          file.url = imgUrl;

          var textPos= app.$refs.postContent.$refs.input.selectionStart;
          app.content = app.content.substr(0,textPos) +'[图片:'+filename+']' + app.content.substr(textPos);

          return Promise.resolve();
        }
        else{
            return Promise.reject();
        }
      })



    },
    delPic:function(files,detail){

        var app = this;
        var tag = '[图片:'+ files.file.name+']';
        console.log("delPic",tag);
        app.content = app.content.replace(tag,'');

        return Promise.resolve();
        // return new Promise(function(resolve,reject){
        //     return resolve();
        // })
    },
      checkPhone:function(){
          if(window.JSInterface) {
              window.JSInterface.callMethod('bindPhone', null)
          }
      }

  },
  mounted:function(){
      this.axios.get("/checkPhone");
  }
}
</script>
<style>
  .van-uploader__upload-text{
    color:#43b292;
    font-size: 12px;
  }
  .van-uploader__upload-icon{
    color:#43b292;
  }
  .van-icon-plus:before{
    font: 14px/1 "FontAwesome";
    font-size: 18px;
    content: "\f0fe"
  }

  .van-cell--required:before{
    color: #eeeeee;
  }
</style>
